import { ReactElement } from 'react';
import { UserSubscription } from '@creditsights/api-ui-web';
import { ContentTypeTag, ArticlePermissions } from '../../../../models';
import { AccessStatus } from '../../../../services/dtos/article/article.dto';
import RequestAccessArticleContent from './RequestAccessArticleContent';
import SubscribeIndividualArticleMessage from './SubscribeIndividualArticleMessage';
import SubscribeMessage from '../../../LockedContent/SubscribeMessage';
import useFetchUserPermissions from '../../../../hooks/permissions/useFetchUserPermissions';
import { trackArticleAccessDenied } from '../../../../utils/articleUtils';

export interface LockedArticleContentProps {
  articlePermissions: ArticlePermissions;
  inlineContent: boolean;
}
const LockedArticleContent = ({ articlePermissions, inlineContent }: LockedArticleContentProps): ReactElement => {
  const { data: userPermissions } = useFetchUserPermissions();

  const { accessStatus, tags } = articlePermissions;
  if (accessStatus === AccessStatus.privateAccessRequired) {
    return <RequestAccessArticleContent />;
  }

  const crSubscriptions = [
    UserSubscription.CR_LFI,
    UserSubscription.CR,
    UserSubscription.CS_CR_LFI,
    UserSubscription.CS_CR,
  ];
  const hasCRPermissions =
    tags.some((tag) => tag.tagId === ContentTypeTag.Covenants) &&
    userPermissions?.userSubscription &&
    crSubscriptions.includes(userPermissions.userSubscription);

  if (accessStatus === AccessStatus.subscriptionRequired && hasCRPermissions) {
    trackArticleAccessDenied(`${articlePermissions.id}`);
    return <SubscribeIndividualArticleMessage inlineContent={inlineContent} />;
  }
  trackArticleAccessDenied(`${articlePermissions.id}`);
  return <SubscribeMessage />;
};

export default LockedArticleContent;
